<template>
  <div>辅料库存</div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="less"></style>
